import { SvgProps } from "components/icons/types";

export const HelpLibraryIcon = ({
  width = 16,
  height = 16,
  ...props
}: SvgProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.2679 11.8489V13.125H10.2071V11.8489C10.2071 11.1451 9.61251 10.5729 8.88106 10.5729H4.1073C3.37638 10.5729 2.78125 11.1451 2.78125 11.8489V13.125H1.72041V11.8489C1.72041 10.5826 2.79133 9.55206 4.1073 9.55206H8.88106C10.197 9.55206 11.2679 10.5826 11.2679 11.8489ZM6.93124 3.98596C7.59692 4.13347 8.13954 4.65155 8.29707 5.2911C8.40369 5.72342 8.34534 6.13788 8.17083 6.48956H8.86356C9.1293 6.48956 9.36162 6.30172 9.39239 6.04754C9.42846 5.74792 9.41519 5.43402 9.34412 5.11296C9.10861 4.05181 8.2138 3.19584 7.10946 2.97738C5.23337 2.60631 3.57741 3.9829 3.57741 5.72393C3.57741 6.47373 3.88452 7.15565 4.38364 7.65943C4.40486 7.2266 4.56717 6.82898 4.82707 6.50793C4.70614 6.2711 4.63824 6.00466 4.63824 5.72342C4.63824 4.60101 5.71871 3.71748 6.93124 3.98596ZM3.77366 2.93093C4.58467 2.1995 5.64657 1.83813 6.75992 1.90448C8.84128 2.03413 10.4723 3.7772 10.4723 5.87246C10.4723 6.7759 9.70905 7.51039 8.77021 7.51039H7.49879C7.3699 7.08623 6.96307 6.7759 6.48039 6.7759C5.89428 6.7759 5.41955 7.23272 5.41955 7.79673C5.41955 8.36074 5.89428 8.81757 6.48039 8.81757C6.76628 8.81757 7.02619 8.70834 7.21661 8.53122H8.76968C10.293 8.53122 11.5326 7.33838 11.5326 5.87246C11.5332 3.24024 9.46665 1.04954 6.82834 0.885692C5.41531 0.79739 4.07494 1.25932 3.04858 2.18623C2.10072 3.04118 1.53105 4.22586 1.46263 5.46923H2.52506C2.5903 4.49791 3.02736 3.60417 3.77366 2.93093Z"
      fill="currentColor"
    />
  </svg>
);
